import { css } from '@firebolt-dev/css'
import { useEffect, useState } from 'react'
import { cls } from '../core/cls'

export function UIEditorFieldSwitch({ options, value, onChange }) {
  return (
    <div
      className='fieldsw'
      css={css`
        flex: 1;
        display: flex;
        align-items: stretch;
        background: var(--bg4);
        border-radius: 5px;
        height: 34px;
        .fieldsw-btn {
          flex: 1;
          border-radius: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
          &.selected {
            background: var(--bg5);
          }
          &:hover {
            cursor: pointer;
          }
        }
      `}
    >
      {options.map(option => (
        <div
          key={option.value}
          className={cls('fieldsw-btn', { selected: option.value === value })}
          onClick={() => onChange(option.value)}
        >
          <span>{option.label}</span>
        </div>
      ))}
    </div>
  )
}
